var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.isOwnerWorkspace)?_c('div',{staticClass:"py-3"},[_c('ClinicSetting')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }